<template>
  <div class="treatments-frequency">

    <div class="filter-container">
      <form class="search-filters" @submit.prevent="onApplyFilters">
        <label>
          Dată de la
          <input v-model="localFilters.dateFrom" type="date">
        </label>
        <label>
          Dată până la
          <input v-model="localFilters.dateTo" type="date">
        </label>
        <label>
          Ultimele luni
          <select v-model.number="localFilters.lastMonths">
            <option :value="null">-</option>
            <option v-for="month in monthOptions" :key="'last-' + month" :value="month">{{ month }} luni</option>
          </select>
        </label>
        <label>
          Medici
          <select v-model="localFilters.doctor">
            <option :value="null">-</option>
            <option v-for="Doctor in Doctors" :key="Doctor" :value="Doctor">{{ Doctor }}</option>
          </select>
        </label>
        <button type="submit" class="search-btn">
          <img src="../assets/icons2/search-icon.svg" alt="search-icon">
        </button>
      </form>

      <div class="action-bar">
        <button class="download-btn" @click="$emit('download', localFilters)" :disabled="isDownloading || isLoading">
          <span v-if="!isDownloading">📥 Descarcă Excel</span>
          <span v-else class="btn-spinner"></span>
        </button>
      </div>
    </div>

    <div class="table-wrapper" :class="{ 'is-loading': isLoading }">
      <div v-if="isLoading" class="table-loader-overlay">
        <div class="spinner"></div>
        <p>Se încarcă datele...</p>
      </div>

      <table class="table">
        <thead>
        <tr>
          <th>#</th>
          <th>Denumire tratament</th>
          <th>Număr</th>
          <th>Procent (%)</th>
        </tr>
        </thead>
        <tbody>
        <tr v-if="items.length === 0">
          <td colspan="4" class="no-data">Nu există date disponibile</td>
        </tr>
        <tr v-else v-for="(item, index) in items" :key="index">
          <td>{{ item.rank }}</td>
          <td>{{ item.denumire }}</td>
          <td>{{ item.count }}</td>
          <td>{{ item.percent }}%</td>
        </tr>
        </tbody>
      </table>
    </div>

    <div class="summary">
      <span>Total tratamente: <b>{{ items.length }}</b></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TreatmentsFrequency',

  props: {
    items: {
      type: Array,
      default: () => []
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    isDownloading: {
      type: Boolean,
      default: false
    },
    Doctors: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      monthOptions: [3, 6, 12],
      localFilters: {
        doctor: null,
        dateFrom: '',
        dateTo: '',
        lastMonths: null,
      }
    };
  },
  watch: {
    'localFilters.lastMonths' (val) {
      if (val != null) {
        this.localFilters.dateFrom = ''
        this.localFilters.dateTo = ''
      }
    }
  },

  methods: {
    onApplyFilters () {
      this.$emit('apply-filters', { ...this.localFilters })
    },
  },

  emits: ['download', 'apply-filters']
}
</script>

<style lang="less">
@import '../assets/styles/var.less';

 .treatments-frequency {
   @media only screen and (min-width: 0) {
     .search-filters {
       display: flex;
       align-items: end;
       margin-bottom: 12px;
       gap: 8px;

       .search-btn {
         background-color: @main-green;
         border: none;
         border-radius: 100%;
         height: 34px;
         width: 34px;
         display: flex;
         cursor: pointer;
         align-items: center;
         justify-content: center;
         transition: opacity 0.1s ease-in-out;

         &:hover {
           opacity: 0.8;
         }
       }

       label {
         display: block;
         font-size: 15px;

         select {
           display: block;
           font-size: 15px;
           border-radius: 2px;
           margin-top: 5px;
           padding: 2px 10px;
           width: 160px;
           height: 35px;
           border: 1px solid #ddd;
         }

         input {
           display: block;
           font-size: 15px;
           border-radius: 2px;
           margin-top: 5px;
           padding: 2px 10px;
           width: 160px;
           height: 35px;
           border: 1px solid #ddd;
         }
       }
     }
     .filter-container {
       display: flex;
       justify-content: space-between;
       align-items: center;
     }
   }
 }
</style>
